import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const LegalLayout = ({ title, eyebrow, children, testid }) => {
  return (
    <div data-testid={testid} className="mx-auto max-w-4xl px-4 py-14 sm:px-8">
      <Link
        to="/"
        data-testid="legal-back-home"
        className="mb-8 inline-flex items-center gap-2 text-sm font-medium text-cyan-400 hover:text-cyan-300"
      >
        <ArrowLeft className="h-4 w-4" />
        Retour à l'accueil
      </Link>

      <div className="mb-10">
        <span className="font-mono text-xs uppercase tracking-widest text-cyan-400">
          {eyebrow}
        </span>
        <h1 className="mt-3 font-heading text-3xl font-extrabold tracking-tight text-slate-50 sm:text-4xl lg:text-5xl">
          {title}
        </h1>
      </div>

      <article className="legal-prose space-y-8 text-slate-300">{children}</article>

      <nav
        data-testid="legal-cross-links"
        className="mt-16 flex flex-wrap items-center gap-3 border-t border-slate-800/70 pt-6 text-sm"
      >
        <span className="font-mono text-[11px] uppercase tracking-widest text-slate-500">
          Autres pages légales :
        </span>
        <Link
          to="/mentions-legales"
          data-testid="cross-link-mentions"
          className="text-slate-300 hover:text-cyan-300"
        >
          Mentions légales
        </Link>
        <span className="text-slate-700">·</span>
        <Link
          to="/politique-confidentialite"
          data-testid="cross-link-confidentialite"
          className="text-slate-300 hover:text-cyan-300"
        >
          Politique de confidentialité
        </Link>
        <span className="text-slate-700">·</span>
        <Link
          to="/propriete-intellectuelle"
          data-testid="cross-link-propriete"
          className="text-slate-300 hover:text-cyan-300"
        >
          Propriété intellectuelle
        </Link>
      </nav>
    </div>
  );
};

export const LegalSection = ({ title, children, testid }) => (
  <section
    data-testid={testid}
    className="surface-card rounded-2xl border border-slate-800/70 bg-slate-900/40 p-6 sm:p-8"
  >
    <h2 className="font-heading text-xl font-bold text-slate-50 sm:text-2xl">
      {title}
    </h2>
    <div className="mt-4 space-y-3 text-sm leading-relaxed text-slate-300 sm:text-base">
      {children}
    </div>
  </section>
);

export const Placeholder = ({ children }) => (
  <span className="inline-flex items-center rounded border border-amber-500/40 bg-amber-500/10 px-1.5 py-0.5 font-mono text-xs font-semibold text-amber-300">
    {children}
  </span>
);
